import { Text } from '@northladder/i18n';
import { getTextFromI18n } from '@northladder/utilities';

import { Checkbox } from '../../../../ui/checkbox-cn';
import { SimpleTooltip } from '../../../../ui/tooltip';

import { IBaseInputCheckItem } from '../../types';

/**
 * -----------------------------------------------------------------------------
 * Creates a theme-able CheckInput component that wraps around s primitive
 * checkbox box with additional self contained labels.
 */
export function CheckInput({
  checked,
  label,
  name,
  onChange,
  required = false,
  title,
  locale,
}: IBaseInputCheckItem) {
  const handleToggleCheck = (newChecked: boolean) => {
    onChange(newChecked);
  };

  const tTitle = getTextFromI18n({ locale, text: title || label });

  return (
    <div className="flex items-start">
      <div className="flex h-5 items-center">
        <Checkbox
          checked={checked}
          id={name}
          onCheckedChange={handleToggleCheck}
          required={required}
        />
      </div>
      <div className="mx-3 text-sm">
        <SimpleTooltip
          className="max-w-[200px]"
          content={tTitle}
          delayDuration={1000}
        >
          <label className="form-label" htmlFor={name}>
            <Text text={label} />
          </label>
        </SimpleTooltip>
      </div>
    </div>
  );
}
